// src/pages/AdminDashboard.js

import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "../api/axiosInstance";
import { FaTruck } from "react-icons/fa";

export default function AdminDashboard() {
  const navigate = useNavigate();
  const [overview, setOverview] = useState(null);



  /* ---------------- LOGOUT ---------------- */
  const handleLogout = () => {
    localStorage.clear();
    navigate("/");
  };

  /* ---------------- LOAD DELIVERY PAYMENT OVERVIEW ---------------- */
  const loadDeliveryPaymentOverview = async () => {
console.log("Calling delivery-payment-overview API");
    try {
      const res = await axios.get("/admin/delivery-payment-overview/");
      setOverview(res.data);
    } catch (err) {
      console.log("Failed to load delivery payment overview", err);
    }
  };

  useEffect(() => {
    loadDeliveryPaymentOverview();
  }, []);


  /* ---------------- STYLES ---------------- */
  const cardStyle = {
    background: "#ffffff",
    borderRadius: "12px",
    padding: "25px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
    textAlign: "center",
    cursor: "pointer",
    transition: "0.2s",
    fontSize: "18px",
    fontWeight: "600",
  };

  const iconStyle = {
    fontSize: "32px",
    marginBottom: "10px",
  };

  return (
    <div style={{ padding: "30px" }}>
      <h1 style={{ textAlign: "center", marginBottom: "20px" }}>
        Admin Dashboard
      </h1>
      <hr />

      {/* GRID */}
      <div
        style={{
          marginTop: "30px",
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))",
          gap: "20px",
          
        }}
      >
        {/* Delivery Monitoring */}
        <div
          style={cardStyle}
          onClick={() => navigate("/admin/delivery-monitor")}
        >
          <div style={iconStyle}>📍</div>
          Delivery Monitoring
          <p style={{ fontSize: 12, color: "#555" }}>
            Live tracking & idle detection
          </p>
        </div>
	


	
        {/* Verify Orders */}
        <div
          style={cardStyle}
          onClick={() => navigate("/admin/order-verification")}
        >
          <div style={iconStyle}>🧪</div>
          Verify Orders
          <p style={{ fontSize: 12, color: "#555" }}>
            Distance • Mode • Charges
          </p>
        </div>
                <div
          style={cardStyle}
          onClick={() => navigate("/admin/monthly-salary")}
        >
          <div style={iconStyle}>🗓️</div>
          Delivery Boy Monthly salary 
          <p style={{ fontSize: 12, color: "#555" }}>
            Monthly Salary Satelement
          </p>
        </div>
                       <div
          style={cardStyle}
          onClick={() => navigate("/admin/base-salary")}
        >
          <div style={iconStyle}>💰</div>
          Delivery Boy Base Salary
          <p style={{ fontSize: 12, color: "#555" }}>
            See/Create Base Salary Of Delivery Boy
          </p>
        </div>
        {/* 🚚 DELIVERY PAYMENTS CARD */}
        <div style={{ ...cardStyle, cursor: "default" }}>
          <h4>🚚 Delivery Payments</h4>

          <p>
            Total Delivery Earning: ₹
            {overview ? overview.total_earning : 0}
          </p>
          <p>
            Total Paid: ₹
            {overview ? overview.total_paid : 0}
          </p>

          <p style={{ color: "red", fontWeight: "bold" }}>
            Pending: ₹
            {overview ? overview.pending_amount : 0}
          </p>

          <button
            className="btn btn-primary"
            onClick={() => navigate("/admin/salary-settlement")}
          >
            Manage Payments
          </button>
        </div>

        {/* Manage Medicines */}
        <Link
          to="/admin/medicine"
          style={{ textDecoration: "none", color: "black" }}
        >
          <div style={cardStyle}>
            <div style={iconStyle}>💊</div>
            Manage Medicines
          </div>
        </Link>

        {/* Manage Surgical */}
        <Link
          to="/admin/surgical"
          style={{ textDecoration: "none", color: "black" }}
        >
          <div style={cardStyle}>
            <div style={iconStyle}>🧴</div>
            Manage Surgical Items
          </div>
        </Link>



	<Link
          to="/search-analytics"
          style={{ textDecoration: "none", color: "black" }}
        >
          <div style={cardStyle}>
            <div style={iconStyle}>🔥</div>
             Search Analytics
          </div>
        </Link>




        {/* contact details of admin and phramcist */}
        <Link
          to="/admin/emergency-contact"
          style={{ textDecoration: "none", color: "black" }}
        >
          <div style={cardStyle}>
            <div style={iconStyle}>📞</div>
            phone of admin and pharmacist
          </div>
        </Link>


        {/* prescripon history */}
        <Link
          to="/admin/rx-panel"
          style={{ textDecoration: "none", color: "black" }}
        >
          <div style={cardStyle}>
            <div style={iconStyle}>📋</div>
            Prescriptions Detailed History
          </div>
        </Link>

        {/* Add Hospital */}
        <Link
          to="/admin/Hospitals"
          style={{ textDecoration: "none", color: "black" }}
        >
          <div style={cardStyle}>
            <div style={iconStyle}>🏥</div>
            Add Hospital
          </div>
        </Link>

        {/* Add Pharmacist */}
        <Link
          to="/admin/Pharmacists"
          style={{ textDecoration: "none", color: "black" }}
        >
          <div style={cardStyle}>
            <div style={iconStyle}>👨‍⚕️</div>
            Add Pharmacist
          </div>
        </Link>

        <Link
          to="/admin/coupons"
          style={{ textDecoration: "none", color: "black" }}
        >
          <div style={cardStyle}>
            <div style={iconStyle}>👨‍⚕️</div>
            Add/Edit Coupons
          </div>
        </Link>







        {/* Orders */}
 

        {/* Daily Cash Settlement */}
        <div
          style={cardStyle}
          onClick={() => navigate("/admin/delivery-cash-settlement")}
        >
          <div style={iconStyle}>💵</div>
          Daily Cash Settlement
        </div>

        {/* Upload Medicine Excel */}
        <Link
          to="/admin/upload-excel"
          style={{ textDecoration: "none", color: "black" }}
        >
          <div style={cardStyle}>
            <div style={iconStyle}>📂</div>
            Upload Medicine Excel
          </div>
        </Link>

        {/* View Medicines */}
        <Link
          to="/shop-medicines"
          style={{ textDecoration: "none", color: "black" }}
        >
          <div style={cardStyle}>
            <div style={iconStyle}>🛒</div>
            View Medicines
          </div>
        </Link>
        <Link
          to="/admin/hospital-settlements"
          style={{ textDecoration: "none", color: "black" }}
        >
          <div style={cardStyle}>
            <div style={iconStyle}>💰</div>
            
            Hospital-Pharmacist Cash Settlement
          </div>
        </Link>
        <Link
          to="/admin/consumer-products"
          style={{ textDecoration: "none", color: "black" }}
        >
          <div style={cardStyle}>
            <div style={iconStyle}>🛍️ </div>
            
            Consumer Products
          </div>
        </Link>

        <Link
          to="/admin/consumer"
          style={{ textDecoration: "none", color: "black" }}
        >
          <div style={cardStyle}>
            <div style={iconStyle}>🛍️ </div>
            
            Add Consumer Products
          </div>
        </Link>


        <Link
          to="/admin/consumer-products-list"
          style={{ textDecoration: "none", color: "black" }}
        >
          <div style={cardStyle}>
            <div style={iconStyle}>🛍️ </div>
            
            Consumer Products Edit/Delete
          </div>
        </Link>

     <Link
  to="/admin/orders"
  style={{ textDecoration: "none", color: "black" }}
>
  <div style={cardStyle}>
    <div style={iconStyle}>🛍️</div>
    Shop Orders Details
  </div>
</Link>


        {/* Upload Surgical Excel */}
        <Link
          to="/admin/upload-surgical-excel"
          style={{ textDecoration: "none", color: "black" }}
        >
          <div style={cardStyle}>
            <div style={iconStyle}>📤</div>
            Upload Surgical Excel
          </div>
        </Link>

        {/* View Surgical Items */}
        <Link
          to="/admin/surgical-excel"
          style={{ textDecoration: "none", color: "black" }}
        >
          <div style={cardStyle}>
            <div style={iconStyle}>🧴</div>
            View Surgical Items
          </div>
        </Link>


<Link
  to="/admin/send-coupon"
  style={{ textDecoration: "none", color: "black" }}
>
  <div style={cardStyle}>
    <div style={iconStyle}>🎁</div>
    Send Coupon WhatsApp
    <p style={{ fontSize: 12, color: "#555" }}>
      Send coupon offer to customers
    </p>
  </div>
</Link>



        {/* Assigned Orders */}
        <div
          style={cardStyle}
          onClick={() => navigate("/admin/assigned-orders")}
        >
          <FaTruck size={40} />
          <p>Assigned Orders</p>
        </div>


        <div
          style={cardStyle}
          onClick={() => navigate("/admin/delivery-config")}
        >
          <FaTruck size={40} />
          <p>Set Courier/ Delivery Charges</p>
        </div>


<div
          style={cardStyle}
          onClick={() => navigate("/admin/courier-orders")}
        >
          <FaTruck size={40} />
          <p>Set Manual Delivery Charges of ORDERS</p>
        </div>



        {/* Assign Delivery Orders */}
        <div
          style={cardStyle}
          onClick={() => navigate("/admin/delivery_orders")}
        >
          <FaTruck size={40} />
          <p>Assign Delivery Orders</p>
        </div>
      </div>

      {/* Logout */}
      <div style={{ textAlign: "center", marginTop: "40px" }}>
        <button
          onClick={handleLogout}
          style={{
            background: "red",
            border: "none",
            padding: "12px 30px",
            borderRadius: "8px",
            color: "#fff",
            fontSize: "18px",
            cursor: "pointer",
            fontWeight: "bold",
          }}
        >
          Logout
        </button>
      </div>
    </div>
  );
}
